import React, { useMemo } from 'react';

import { AnalyticsContext } from '@atlaskit/analytics-next';

import { useOnDismissDialog } from '../../../analytics/use-on-dismiss-dialog';
import { useEditionAwareness } from '../../../services/edition-awareness-context';
import { getHamsKey } from '../../../services/product-to-hams-key';
import { ModalEntryPoint } from '../shared/modal-entry-point';

import { PlanSelectionPageModalType } from './dialog';
import { DIALOG_CONFIG } from './dialog-config';
import { entryPoint } from './entrypoint';

const MODAL_CONFIGS = {
	twc: {
		width: '968px',
		height: '808px',
	},
	'reverse-trial': {
		width: '990px',
		height: '700px',
	},
};

export function PlanSelectionPageDialog({ type }: { type: PlanSelectionPageModalType }) {
	const { cloudId, product } = useEditionAwareness();

	const { width, height } = MODAL_CONFIGS[type];

	const entryPointParams = useMemo(
		() => ({
			cloudId,
			hamsProductKey: getHamsKey(product),
		}),
		[cloudId, product],
	);

	const onClose = useOnDismissDialog({ ...DIALOG_CONFIG });

	const entryPointProps = useMemo(() => ({ onClose, type }), [onClose, type]);

	const modalProps = useMemo(
		() => ({
			width,
			height,
			autoFocus: false,
			shouldScrollInViewport: false,
			shouldCloseOnEscape: true,
		}),
		[width, height],
	);

	return (
		<AnalyticsContext data={DIALOG_CONFIG}>
			<ModalEntryPoint
				entryPointProps={entryPointProps}
				entryPoint={entryPoint}
				entryPointParams={entryPointParams}
				modalProps={modalProps}
			/>
		</AnalyticsContext>
	);
}
